<template>
<div class="my-micro-course-wrapper">
    <ctl-header title="我的课程" :onBack="onBack"></ctl-header>
    <van-tabs v-model="type" animated color="#53CB85" sticky style="background: #FAFAFA" title-active-color="#53CB85" @change="getList(1)">
        <van-tab v-for="(v,i) in typeList" :key="i" :title="v.name" :name="v.id"></van-tab>
    </van-tabs>
    <van-pull-refresh v-model="refreshLoading" @refresh="()=>{this.getList(1)}">
        <!-- 列表 -->
        <van-list
            v-if="list.length > 0"
            v-model="loading"
            :error-text="'请求失败， 点击重新加载'"
            :error.sync="error"
            :finished="finished"
            finished-text="没有更多了"
            @load="getList()"
        >
            <div class="card" v-for="(v,i) in list" :key="i" @click="goDetail(v)">
                <div class="card-left">
                    <img class="card-cover" :src="v.picture" alt="">
                </div>
                <div class="card-right">
                    <div class="name show-ellipsis">{{v.courseName}}</div>
                    <div v-if="v.invalidFlag === 1" class="time">{{v.validDate}} 已过期</div>
                    <div v-else class="time">{{v.validDate}} {{ v.userStatus ? `${v.userStatus > 100 ? 100 : v.userStatus}` : '未学习' }}</div>
                </div>
                <img class="card-type" v-if="v.type === 2" src="@/assets/microCourse/kclb_img_xlkbq.png">
            </div>
        </van-list>
        <div v-else class="none-order">
            <img alt="" src="@/assets/order/picture_noorder.png">
            <p>暂无数据</p>
        </div>
    </van-pull-refresh>
</div>
</template>

<script>
import { Button, List, PullRefresh, Tab, Tabs, Toast, Icon } from 'vant'
export default {
    components: {
        [List.name]: List,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Button.name]: Button,
        [Toast.name]: Toast,
        [Icon.name]: Icon,
        [PullRefresh.name]: PullRefresh
    },
    name: 'myMicroCourseIndex',
    data () {
        return {
            type: '0',
            list: [],
            typeList: [{ id: '0', name: '全部' }, { id: '1', name: '可学习' }, { id: '2', name: '已过期' }],
            pageData: {
                current: 1,
                size: 5
            },
            source: '',
            cityCode: '',
            refreshLoading: false,
            loading: false,
            error: false,
            finished: false
        }
    },
    created () {
        // 设置基础数据
        let { source, cityCode } = this.$route.query
        this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || cityCode
        this.source = source
        this.getList(1)
    },
    methods: {
        // 返回
        onBack () {
            if (this.source === 'app') {
                this.$jsBridge.callBackHandler('returnLastPage')
                return
            }
            this.$router.back()
        },
        // 跳转详情
        goDetail (v) {
            if (v.courseState === 2) {
                Toast('该课程已停用，请稍后再试或联系斑斑客服')
                return
            }
            if (!v.groundFlag) {
                Toast('该商品已下架，请稍后再试或联系斑斑客服')
                return
            }
            if (v.invalidFlag) {
                Toast('该商品已过期')
                return
            }
            let courseId = v.courseId
            let coverUrl = v.picture
            let courseName = v.courseName
            let postData = {
                courseId: courseId,
                cityCode: this.cityCode
            }
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.$api.getCourseDetail(postData).then(res => {
                Toast.clear()
                if (res.status) {
                    if (v.type === 1) {
                        this.$jsBridge.callBackHandler('pushMicroCourseVideoDetailPage', { courseId, coverUrl, courseName })
                    } else {
                        this.$router.push({ name: 'seriesCourse', query: { id: courseId } })
                    }
                } else {
                    Toast(res.message)
                }
            })
        },
        // 获取数据
        getList (refresh) {
            if (refresh) {
                this.pageData.current = 1
            }
            const postData = Object.assign({ type: this.type }, this.pageData)
            this.$api.myCourse(postData).then(res => {
                this.error = false
                if (res.status) {
                    if (refresh) {
                        this.list = res.result.records
                    } else {
                        this.list.push(...res.result.records)
                    }
                    this.pageData.current++
                    this.finished = res.result.records.length < this.pageData.size // 首次加载的数据不能铺满屏幕， 设置加载完毕状态， 不再触发load
                } else {
                    this.error = true
                }
                this.refreshLoading = false
                this.loading = false
            })
        }
    }
}
</script>

<style scoped lang="scss">
.show-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
}
.my-micro-course-wrapper{
    .card{
        display: flex;
        align-items: center;
        position: relative;
        background: #FFFFFF;
        box-shadow: 0 0 5px 0 rgba(0,0,0,0.05);
        border-radius: 5px;
        padding: 15px;
        margin: 0 0 10px 0;

        .card-type{
            width: 52px;
            position: absolute;
            right: 0;
            top: 0;
        }
        .card-left{
            font-size: 0;
        }
        .card-right{
            flex: 1;
            line-height: 1;
            height: 80px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin: 0 0 0 8px;
            .name{
                word-break: break-all;
                font-size: 15px;
                color: #333333;
            }
            .time{
                font-size: 13px;
                color: #999999;
            }
        }
        .card-cover{
            width: 155px;
            height: 100px;
            background: #000000;
            border-radius: 5px;
        }

    }
    .van-tabs{
        width: 100%;
    }
    .van-pull-refresh{
        width: 100%;
        box-sizing: border-box;
        padding: 10px 10px 0;
        background: #fafafa;
        height: calc(100vh - 98px);
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }
    .none-order {
        text-align: center;
        img {
            margin-top: 150px;
            width: 150px;
            margin-bottom: 38px;
        }

        p {
            font-size: 18px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
        }
    }
}

/deep/ {
    .van-tab--active .van-tab__text--ellipsis,.van-tab--active .van-tab__text {
        font-size: 15px;
    }
    .van-tab__text--ellipsis,.van-tab__text {
        font-size: 13px;
    }
}
</style>
